import React from 'react';
import { FiMapPin, FiPhone, FiMail, FiClock, FiStar, FiArrowRight } from 'react-icons/fi';
import { 
  FaCcVisa, 
  FaCcMastercard, 
  FaCcAmex, 
  FaCcDiscover 
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      {/* CTA Banner */}
      <div className="footer__cta-banner">
        <div className="container">
          <div className="footer__cta-content">
            <div className="footer__cta-text">
              <h2 className="footer__cta-title">Ready to Restore Your Vehicle?</h2>
              <p className="footer__cta-subtitle">Get your free estimate today and experience the Axis difference</p>
            </div>
            <div className="footer__cta-actions">
              <button className="footer__cta-btn footer__cta-btn--primary" onClick={scrollToContact}>
                <span>Get Free Estimate</span>
                <FiArrowRight />
              </button>
              <a href="tel:+18326156065" className="footer__cta-btn footer__cta-btn--secondary">
                <FiPhone />
                <span>(832) 615-6065</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="footer__main">
        <div className="container">
          <div className="footer__grid">
            {/* Company Info */}
            <div className="footer__column footer__column--main">
              <div className="footer__logo">
                <h3 className="footer__logo-text">AXIS COLLISION</h3>
                <p className="footer__logo-tagline">Expert Auto Body Repair</p>
              </div>
              <p className="footer__description">
                Trusted auto collision repair serving Spring, TX since 2015. 
                We combine expert craftsmanship with personalized service to restore your vehicle to perfection.
              </p>
              <div className="footer__badge">
                <FiStar className="footer__badge-icon" />
                <div className="footer__badge-content">
                  <strong>5.0 Rating</strong>
                  <span>100% Customer Satisfaction</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer__column">
              <h4 className="footer__heading">Quick Links</h4>
              <ul className="footer__list">
                <li><button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}>Our Services</button></li>
                <li><button onClick={() => document.getElementById('why-choose-us')?.scrollIntoView({ behavior: 'smooth' })}>Why Choose Us</button></li>
                <li><button onClick={() => document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' })}>Gallery</button></li>
                <li><button onClick={scrollToContact}>Contact Us</button></li>
                <li><a href="https://www.carwise.com/auto-body-shops/axis-collision-spring-tx-77388/628308" target="_blank" rel="noopener noreferrer">Read Reviews</a></li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer__column">
              <h4 className="footer__heading">Our Services</h4>
              <ul className="footer__list">
                <li>Free Estimates</li>
                <li>Insurance Assistance</li>
                <li>Lifetime Warranty</li>
                <li>Collision Repair</li>
                <li>Towing Services</li>
                <li>Automotive Glass</li>
                <li>Paintless Dent Repair</li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer__column">
              <h4 className="footer__heading">Contact Info</h4>
              <div className="footer__contact">
                <a href="https://maps.google.com/?q=20923+Holzwarth+Road,+Spring,+TX+77388" target="_blank" rel="noopener noreferrer" className="footer__contact-item">
                  <FiMapPin />
                  <span>20923 Holzwarth Road<br />Spring, TX 77388</span>
                </a>
                <a href="tel:+18326156065" className="footer__contact-item">
                  <FiPhone />
                  <span>(832) 615-6065</span>
                </a>
                <a href="mailto:info@axiscollisioncenter.com" className="footer__contact-item">
                  <FiMail />
                  <span>info@axiscollisioncenter.com</span>
                </a>
                <div className="footer__contact-item">
                  <FiClock />
                  <span>Mon-Fri: 8AM-5:30PM<br />Sat: 9AM-12PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* Payment & Languages */}
          <div className="footer__info-bar">
            <div className="footer__info-section">
              <h5 className="footer__info-heading">We Accept</h5>
              <div className="footer__payments">
                <div className="payment-icon" title="Visa"><FaCcVisa /></div>
                <div className="payment-icon" title="Mastercard"><FaCcMastercard /></div>
                <div className="payment-icon" title="American Express"><FaCcAmex /></div>
                <div className="payment-icon" title="Discover"><FaCcDiscover /></div>
              </div>
            </div>
            <div className="footer__info-section">
              <h5 className="footer__info-heading">Languages</h5>
              <div className="footer__languages">
                <span>English</span>
                <span>•</span>
                <span>Español</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-content">
            <p>&copy; {currentYear} Axis Collision Center. All rights reserved.</p>
            <p className="footer__bottom-tagline">Professional Auto Collision Repair in Spring, Texas</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
